import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import banner from "../../images/installingPaversConcrete/blog-installing-pavers-banner.jpg";
import img001 from "../../images/installingPaversConcrete/blog-installing-pavers-001.jpg";
import img002 from "../../images/installingPaversConcrete/blog-installing-pavers-002.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const InstallingPaversConcreteData = {
  title:
    "Installing Pavers Over Concrete: Best Practices and Potential Problems",
  image: banner,
  destination:
    "/blog/installing-pavers-concrete-best-practices-potential-problems",
  date: "September 20, 2016",
  categories: [
    "blog",
    "contractors",
    "driveways",
    "patios",
    "paving-stones",
    "walkways",
  ],
};

const InstallingPaversConcrete = () => {
  const blog = [InstallingPaversConcreteData];

  return (
    <>
      <SEO
        title="How to Install Pavers Over Concrete: Best Practices & Problems"
        description="Looking to install pavers over concrete? Read this blog to learn the best practices, benefits, and potential problems you may face from our experts."
        profileURL={
          "https://www.pacificpavingstone.com/blog/installing-pavers-concrete-best-practices-potential-problems"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/installing-pavers-concrete-best-practices-potential-problems",
          headline:
            "How to Install Pavers Over Concrete: Best Practices & Problems",
          description:
            "Looking to install pavers over concrete? Read this blog to learn the best practices, benefits, and potential problems you may face from our experts.",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-installing-pavers-banner.e07b5752.jpg",
          },
          datePublished: "2016-09-20",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              The time has come where you can’t stand the look of your old
              concrete driveway, patio or walkway any longer. For many Southern
              California homeowners, the thought of tearing up existing concrete
              and upgrading to paving stones sounds overwhelming and costly.
              <br />
              <br />
              Luckily, there may be a simple solution that will help increase
              the curb appeal of your home: installing pavers over the existing
              concrete.
            </p>
            <h4>Benefits of Pavers</h4>
            <p>
              Approximately 50 percent of newly installed driveways in Los
              Angeles and surrounding areas are made of poured concrete. While
              they usually cost less than other types of driveways, concrete is
              more prone to cracking, is difficult or impossible to repair, and
              has ugly expansion joints.
              <br />
              <br />
              Paving stones have become an increasingly popular material for new
              driveways, patios, pool decks and walkways, particularly in
              Southern California. Although the cost of pavers is higher than
              concrete, pavers offer a number of features that other materials
              do not.
              <br />
              <br />
              Paving stones come in hundreds of colors, styles, textures and
              patterns, allowing you to create a one-of-a-kind look for your
              driveway, patio or pool deck. Plus, pavers have a classy look,
              last for decades, and can easily be repaired if needed.
              <br />
              <br />
              When it comes to installing concrete pavers, there are two main
              options: regular paver installs and overlays. In a regular
              install, your paving contractor will start from scratch by
              excavating the area and laying down pavers. This technique is used
              when you don’t already have concrete laid down or when there’s
              significant damage to the concrete and/or foundation.
              <br />
              <br />
              In cases where you already have a concrete driveway or patio
              that’s in good condition, pavers could potentially be laid
              directly over concrete. This is known as an overlay, and while
              it’s a great option for homeowners, it’s not feasible in every
              situation.
            </p>
            <h4>Considerations Before Installing Pavers Over Concrete</h4>
            <img src={img001} alt="Feature" />
            <p>
              One of the best ways to improve the look of your existing concrete
              driveway, walkway, patio or pool deck is to lay pavers on top of
              it. It’s fairly easy for a professional paving company to do, but
              there are some things to consider before you get started.
              <br />
              <br />
              It’s important that your existing concrete is in good shape – no
              large cracks, a smooth surface, etc. Additionally, there needs to
              be enough room to add a paver on top of the concrete without it
              blocking any doorways or causing a tripping hazard.
            </p>
            <h4>The Best Way to Install Pavers Over Concrete</h4>
            <p>
              Before installing pavers over concrete, the surface is cleaned
              with pressure washer to remove any dirt or debris. Once the
              concrete has dried, border pavers will be glued down using mortar
              or a construction adhesive.
              <br />
              <br />
              Then, a one-inch thick layer of sand is added across the entire
              area where the pavers will be laid down. This helps drain water
              away from the pavers and off the concrete slab.
              <br />
              <br />
              The next step involves adding pavers on top of the sand. Once all
              all the pavers are laid and cut, polymeric sand is swept into the
              joints to lock the interior pavers together without gluing them
              down.
              <br />
              <br />
              Problems with Installing Pavers Over Concrete
              <br />
              <br />
              Installing pavers over concrete doesn’t work in every situation.
              If the base underneath the concrete is failing, you’ll need to
              take out the concrete and start from scratch. Since something
              underneath the foundation needs to be addressed, this isn’t a
              situation where you can chip out the problematic section and fix
              it.
              <br />
              <br />
              For example, if you have a crack in your driveway that settles 1/8
              of an inch each year, in eight years, you’ll have a section of
              that’s one-inch lower than the rest of your driveway. If you
              install pavers over the concrete without addressing the foundation
              issue, this will lead to major problems down the road.
              <br />
              <br />
              Before installing pavers over concrete, be mindful of the height
              of the pavers. Certain pavers may be too tall for your space,
              leading to tripping hazards, blocked doors, drainage issues or
              uneven surfaces. In some cases, using shorter pavers (such as ones
              that are one-inch tall specifically made for overlays) may address
              this problem.
            </p>
            <h4>Why You Should Hire a Professional</h4>
            <img src={img002} alt="Feature" />
            <p>
              There are many tutorials and videos online for how to install
              pavers over concrete. While many people have tried to do this job
              on their own, it often leads to mistakes and poor results. If
              you’re thinking of upgrading your concrete driveway, patio or pool
              deck, the best thing you can do is hire a professional to do the
              work for you.
              <br />
              <br />
              There are many things to consider when installing paving stones
              such as creating a pattern, leveling the pavers, properly spacing
              out pavers, cutting pavers, installing on curves and more. For
              these reasons, it’s best to let a professional paving contractor
              do the work for you.
              <br />
              <br />
              At Pacific Pavingstone, we have decades of experience installing
              paving stone driveways, patios, pool decks and other outdoor
              spaces. We understand the challenges that homeowners face when
              installing pavers over concrete. By letting us handle the work,
              you’ll benefit from a better final product that’s completed
              quicker, freeing up your time in the process.
              <br />
              <br />
              We’ve completed tens of thousands of{" "}
              <Link to="/gallery">paving projects</Link>, and we can help you
              assess whether an overlay is the right option for your paving
              project.
            </p>
            <p>
              <Link to="/contact-us">
                Whether you’re looking to upgrade your driveway, patio or pool
                deck, Pacific Pavingstone is here to help you with your next
                paving project. Contact us today for a free consultation!
              </Link>
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(InstallingPaversConcrete);
